import { Stack } from '@mui/material'
import { FilterChip } from './FilterChip'
import { DateTime } from 'luxon'

export const FilterChips = <L extends Partial<Record<keyof L, string>>, V extends Partial<Record<keyof L, unknown>>>({
  formDataLabels,
  values,
  onDeleteChip
}: {
  formDataLabels: L
  values: V
  onDeleteChip: (key: keyof L) => void
}) => {
  return (
    <Stack direction={'row'} spacing={'var(--spacing-2xs)'} sx={{ flexWrap: 'wrap' }}>
      {getKeyValueLabelTuples(formDataLabels, values).map(({ key, value, label }) => (
        <FilterChip
          key={String(key)}
          label={label}
          value={value instanceof DateTime ? (value as DateTime).toFormat('D') : String(value)}
          onDelete={() => {
            onDeleteChip(key)
          }}
        />
      ))}
    </Stack>
  )
}

//function that returns a union type of all the key names of an object
function getKeyValueLabelTuples<T extends object>(formDataLabels: T, values: Partial<Record<keyof T, unknown>>) {
  return getKeys(formDataLabels)
    .map(key => ({ key: key, value: values[key], label: formDataLabels[key]! }))
    .filter(({ value }) => !!value)
}
//function that returns a union type of all the key names of an object
function getKeys<T extends object>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[]
}
